import {SigninForm} from "../molecules/SigninForm";
import ProgressBar from "./ProgressBar";
import {Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis} from "recharts";
import React, {useEffect, useState} from "react";
import {extractCompanyName, getFormatted} from "./jobUtils";
import axios from "axios";
import {getAxiosBaseUrl} from "../../config";

export default function JobAppAdmin() {
	var signedin = sessionStorage.getItem("signedin");
	const [joburls, setjoburls] = useState([]);
	const [alldatalength, setAllDataLength] = useState(0);
	const [companyChartData, setcompanyChartData] = useState([]);
	const [fltrdjoburls, setfltrdjoburls] = useState([]);
	const [jobLocations, setjobLocations] = useState([]);
	
	useEffect(() => {
		function getAccessToken() {
			getAndSetJobData();
			// getGisData();
		}
		
		getAccessToken();
	}, []);
	
	function getDictionaryForCompanyData(allData) {
		const count = {};
		const countProcessed = {};
		allData.forEach(rec => {
			const name = extractCompanyName(rec['jobUrl']);
			count[name] = (count[name] || 0) + 1;
			if ('date_posted' in rec) {
				countProcessed[name] = (countProcessed[name] || 0) + 1;
			}
		});
		
		const companyChartData = Object.keys(count).map(key => {
			if (key == 'Amazon') {
				return ({name: key, availableCount: 0, processedCount: 0})
			}
			return {
				name: key, processedCount: countProcessed[key] || 0, availableCount: count[key] - (countProcessed[key] || 0),
			};
		})
		return companyChartData;
	}
	
	function getAndSetJobData() {
		axios.defaults.baseURL = getAxiosBaseUrl();
		axios.post('fetchJobUrlsEs', {
			'verifiedemail': sessionStorage.getItem("verifiedemail")
		}).then(response => {
			const allData = response.data
			setAllDataLength(allData.length)
			const filteredData = allData.filter(rec => 'date_posted' in rec)
			
			let companyChartData = getDictionaryForCompanyData(allData)
			setcompanyChartData(companyChartData)
			// setjobSummaryCount(companyChartData.length);
			// const filteredData = allData
			setjoburls(filteredData);
			setfltrdjoburls(filteredData);
			const allLatLongs = []
			filteredData.map(rec => {
				if ('latlongs' in rec) {
					rec['latlongs'].split(';').map(latLong => {
						const lat_ = latLong.split(',')[0]
						const long_ = latLong.split(',')[1]
						allLatLongs.push({
							'title': rec.title, 'company': extractCompanyName(rec.jobUrl), 'jobUrl': rec.jobUrl, 'lat': lat_, 'lon': long_
						})
					})
				}
			})
			setjobLocations(allLatLongs);
		})
	}
	
	if (!signedin) {
		return <div style={{marginTop: "300px"}}>
			<SigninForm/>
		</div>
	} else {
		return (<div style={{
			marginTop: "10px", marginLeft: "0px", minHeight: "0px",
		}}>
			<div style={{fontSize: "20px", display: "flex"}}>Jobs Admin Page</div>
			<div style={{marginBottom: "0px", display: "flex"}}>
				<div style={{fontSize: "5x"}}> Available Jobs: {getFormatted(alldatalength)}</div>
				<div style={{fontSize: "5x", marginLeft: "10px"}}> Job Summary Available for: {getFormatted(joburls.length)}</div>
			</div>
			<ProgressBar totalJobs={alldatalength} summaryAvailable={joburls.length}/>
			<div style={{marginTop: "5px", marginBottom: "20px", display: "flex"}}>
				<BarChart width={600} height={300} data={companyChartData} margin={{right: 30, left: 20, top: 20}}>
					<CartesianGrid strokeDasharray="3 3"/>
					<XAxis dataKey="name" angle={-45} textAnchor="end" interval={0} height={70}/>
					<YAxis/>
					<Tooltip/>
					<Legend wrapperStyle={{position: 'relative', top: -5}}/>
					<Bar dataKey="processedCount" fill="#8884d8" stackId="a" name="Processed"/>
					<Bar dataKey="availableCount" fill="#82ca9d" stackId="a" name="Processing"/>
				</BarChart>
			</div>
		</div>)
	}
}